<div class="content">
    <h1 class="h1">You are not authorized to view this page.</h1>
</div>
